<template>
  <a-modal title="编辑配置" :visible="visible" okText="保存" @ok="handleSubmit" @cancel="handleHide" :width="800">
    <a-icon
      slot="icon"
      @click="$router.back(-1)"
      style="font-size: 18px; margin-top: 4px; margin-right: 5px"
      type="arrow-left"
    ></a-icon>
    <a-card :bordered="false">
      <a-form :form="form" style="max-width: 700px; margin: 0px 100px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-divider :dashed="true" orientation="left">商品信息</a-divider>
        <a-form-item label="商品ID">
          <a-input placeholder="请输入商品ID" v-model="params.goods_id"></a-input>
          <a-button @click="getGoods(false)" type="primary" :loading="infoLoading">
            解析ID
          </a-button>
        </a-form-item>
        <a-form-item label="商品来源">
          <a-radio-group v-model="params.goods_type">
            <a-radio-button value="tb">
              淘宝
            </a-radio-button>
            <!-- <a-radio-button value="jd">
              京东
            </a-radio-button>
            <a-radio-button value="pdd">
              拼多多
            </a-radio-button> -->
          </a-radio-group>
        </a-form-item>
        <a-form-item label="发圈类型">
          <a-radio-group @change="e => (type = e.target.value)" v-model="params.trend_type">
            <a-radio-button :value="1">
              图文
            </a-radio-button>
            <a-radio-button :value="2">
              文本
            </a-radio-button>
            <a-radio-button :value="3">
              视频
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-divider :dashed="true" orientation="left">发圈内容</a-divider>
        <a-form-item label="文案">
          <a-textarea :style="width" :autoSize="{ minRows: 3 }" v-model="params.trend_text">
            <a-icon slot="addonAfter" type="setting" />
          </a-textarea>
        </a-form-item>
        <a-form-item v-show="type === 1" label="图片">
          <div class="clearfix">
            <a-upload
              accept=".jpg, .jpeg, .png"
              list-type="picture-card"
              :file-list="imgList"
              @preview="handlePreview"
              @change="handleImgChange"
              :customRequest="uploadImg"
            >
              <div v-if="imgList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  上传图片
                </div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item v-show="type === 3" label="视频封面">
          <div class="clearfix">
            <a-upload
              accept=".jpg, .jpeg, .png"
              list-type="picture-card"
              :file-list="videoImgList"
              @preview="handlePreview"
              @change="handleVideoImgChange"
              :customRequest="uploadVideoImg"
            >
              <div v-if="videoImgList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  上传图片
                </div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item v-show="type === 3" label="视频">
          <div class="clearfix">
            <a-upload
              accept=".mp4, .avi, .flv"
              list-type="picture"
              :file-list="videoList"
              @preview="handleVideoPreview"
              @change="handleVideoChange"
              :customRequest="uploadVideo"
            >
              <a-button v-if="videoList.length < 1"> <a-icon type="upload" /> 上传视频 </a-button>
              <!-- <div v-if="videoList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div> -->
            </a-upload>
          </div>
        </a-form-item>
        <a-divider :dashed="true" orientation="left">评论留言</a-divider>
        <a-form-item label="评论">
          <a-input-group>
            <div v-for="(item, index) in messageList" :key="index" :style="{ marginBottom: '10px' }">
              <a-row :gutter="20">
                <a-col :span="16">
                  <a-textarea
                    :style="width"
                    :rows="{ minRows: 2, maxRows: 4 }"
                    style="margin-bottom: 10px"
                    placeholder="评论信息"
                    v-model="messageList[index]"
                  ></a-textarea>
                  <a-tag @click="copy(item)" v-for="(item, index) in nods" v-bind:key="index">
                    {{ item }}
                  </a-tag>
                </a-col>
                <a-col :span="8">
                  <a-popconfirm ok-text="确定" cancel-text="取消" @confirm="messageList.splice(index, 1)">
                    <a-button icon="close" size="small" type="danger" :style="{ marginRight: '5px' }" shape="circle">
                    </a-button>
                    <template slot="title">
                      删除评论吗？
                    </template>
                  </a-popconfirm>
                  <emoji-dialog @cencel="copyEmoji" />
                  <message-dialog :style="{ marginLeft: '5px' }" @append="handleAppendMsg" />
                </a-col>
              </a-row>
            </div>
          </a-input-group>
          <a-button
            :style="width"
            :disabled="messageList.length >= 4"
            type="dashed"
            @click="messageList.push('')"
            block
          >
            {{ 4 - messageList.length }}条评论可添加
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-modal>
</template>

<script>
import { PageView } from '@/layouts'
import PageHeader from 'ant-design-vue/es/page-header'
import Comment from 'ant-design-vue/es/comment'
import { TreeSelect } from 'ant-design-vue'
import { readFileAsBuffer, upload } from '@/utils/oss'
import EmojiDialog from '../components/EmojiDialog'
// import { TreeSelect as trs } from 'ant-design-vue'
import MessageDialog from './MessageDialog'
import MobileModel from './MobileModel'
import RobotMultiple from '@/views/components/RobotMultiple'
import { queryGoodInfo, editTaskOfPyq } from '@/api/pyq'
import moment from 'moment'
const nods = ['[淘口令]', '[京东短链接]', '[拼多多短链接]', '[原价]', '[券后价]', '[券面值]', '[商品标题]', '[中间页]']
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

// const SHOW_PARENT = trs.SHOW_PARENT
export default {
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 8 }, sm: { span: 8 } },
      wrapperCol: { lg: { span: 16 }, sm: { span: 16 } },
      nods,
      visible: false,
      infoLoading: false,
      previewVisible: false,
      previewVideoVisible: false,
      previewImage: '',
      userTree: [],
      previewVideo: '',
      messageList: [''],
      imgList: [],
      videoList: [],
      videoImgList: [],
      type: 1,
      sendType: 1,
      sendTime: null,
      width: {
        width: '300px'
      },
      treeData: [],
      params: {}
    }
  },
  components: {
    PageView,
    PageHeader,
    TreeSelect,
    EmojiDialog,
    MessageDialog,
    MobileModel,
    Comment,
    RobotMultiple
  },

  methods: {
    moment,
    handleHide() {
      this.visible = false
      this.params = {}
      this.messageList = []
      this.imgList = []
      this.form.resetFields('robotids')
    },
    show(record) {
      this.visible = true
      this.params = record
      setTimeout(() => {
        if (this.visible) {
          this.form.setFieldsValue({
            robotids: [record.sub_id]
          })
        }
      }, 500)
      if (JSON.stringify(record) !== '{}') {
        switch (record.trend_type) {
          case 1:
            const _img_list = JSON.parse(this.params.image_url)
            _img_list.forEach((v, i) => {
              this.imgList.push({
                uid: i - 1,
                name: `${1}.jpg`,
                status: 'done',
                url: `${v}`
              })
            })
            break
        }
        this.messageList = JSON.parse(this.params.tend_comment)
      }
    },
    copy(text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    onSelect(selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
    },
    onCheck(checkedKeys, info) {
      // console.log('onCheck', checkedKeys, info)
    },
    handleAppendMsg(text) {
      if (this.messageList.length >= 4) {
        this.$message.error('评论最大可添加4个！')
      } else {
        this.messageList.push(text)
      }
    },
    getGoods(type) {
      this.infoLoading = true
      queryGoodInfo({
        goods_id: type ? this.params.goods_id : this.params.goods_id,
        goods_type: type ? 'tb' : this.params.goods_type
      })
        .then(res => {
          this.$message.success('解析完成')
          if (res.code != 1) {
            this.$message.error(res.msg)
            return false
          }
          if (res.data.shipai_pic.length !== 0 && res.data.shipai_pic !== '[]') {
            this.form.setFieldsValue({
              trend_text: res.data.circle_text
            })
            this.imgList = []
            const shipai = res.data.shipai_pic.slice(1, res.data.shipai_pic.length - 1)
            // console.log(shipai.split(','))

            shipai.split(',').forEach((v, i) => {
              this.imgList.push({
                uid: i - 1,
                name: `${1}.jpg`,
                status: 'done',
                url: `${v}`
              })
            })
          }
        })
        .finally(() => {
          this.infoLoading = false
        })
    },
    handleCancel() {
      this.previewVisible = false
    },

    copyEmoji(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    pushMessage() {
      if (this.message === '') {
        this.$message.error('请输入评论内容')
        return null
      }
      this.messageList.push(this.message)
      this.message = ''
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewVideo = file.url || file.preview
      this.previewVideoVisible = true
    },
    handleImgChange({ fileList }) {
      this.imgList = fileList
    },
    handleVideoImgChange({ fileList }) {
      this.videoImgList = fileList
    },
    handleVideoChange({ fileList }) {
      this.videoList = fileList
    },
    uploadImg(file) {
      // console.log(file)
      readFileAsBuffer(file.file)
        .then(builderFile => {
          upload(builderFile, file.file, 'images')
            .then(res => {
              // console.log(res, 'res')
              file.onSuccess({
                name: res.data.name,
                status: 'done',
                thumbUrl: res.url,
                url: res.url
              })
            })
            .catch(err => {
              file.onError(err)
            })
        })
        .catch(err => {
          file.onError(err)
        })
    },
    uploadVideoImg(file) {
      readFileAsBuffer(file.file)
        .then(builderFile => {
          upload(builderFile, file.file, 'videoImg')
            .then(res => {
              file.onSuccess({
                name: res.data.name,
                status: 'done',
                thumbUrl: res.url,
                url: res.url
              })
            })
            .catch(err => {
              file.onError(err)
            })
        })
        .catch(err => {
          file.onError(err)
        })
    },
    uploadVideo(file) {
      let fileSize = file.file.size
      fileSize = Math.round(fileSize / 1024 / 1024) // 单位为KB
      if (fileSize >= 10) {
        setTimeout(() => {
          file.onError('视频最大为10MB')
          alert('视频最大尺寸为10MB，请重新上传!')
        }, 300)
      } else {
        readFileAsBuffer(file.file)
          .then(builderFile => {
            upload(builderFile, file.file, 'video')
              .then(res => {
                // console.log(res)
                file.onSuccess({
                  name: res.data.name,
                  status: 'done',
                  thumbUrl: res.url,
                  url: res.url
                })
              })
              .catch(err => {
                file.onError(err)
              })
          })
          .catch(err => {
            file.onError(err)
          })
      }
    },
    replace(str) {
      if (str.indexOf('\\ue') !== -1) {
        // eslint-disable-next-line no-eval
        var a = str.substr(str.indexOf('\\ue'), 6)
        str = str.replace(a, eval("'" + a + "'"))
        return this.replace(str)
      } else {
        return str
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const imgs = []
          if (this.imgList.length > 0) {
            this.imgList.forEach((v, i) => {
              if (v.url) {
                imgs.push(v.url)
              } else {
                imgs.push(v.response.url)
              }
            })
          }
          this.loading = true
          let mess = []
          if (this.messageList.length > 0) {
            this.messageList.forEach((v, i) => {
              mess.push(this.replace(v))
            })
          }
          const { params } = this
          const hide = this.$message.loading('请稍后')
          editTaskOfPyq({
            trend_name: params.trend_name,
            sub_id: params.sub_id,
            image_url: imgs,
            tend_comment: this.messageList,
            trend_text: params.trend_text ? this.replace(params.trend_text) : '',
            video_url: this.videoList.length > 0 ? this.videoList[0].response.url : '',
            video_image_url: this.videoImgList.length > 0 ? this.videoImgList[0].response.url : '',
            trend_type: params.trend_type,
            goods_id: params.goods_id,
            goods_type: params.goods_type,
            send_time: params.send_time,
            id: params.id
          })
            .then(res => {
              if (res.code === 1) {
                this.$message.success('保存成功')
                this.handleHide()
                this.$emit('ok')
              } else {
                this.$message.error(res.message)
              }
            })
            .finally(res => {
              hide()
              this.loading = false
            })
          // console.log(this.userTree)
          // SaveSendConfig(values).then(() => {
          //   this.$message.success('保存成功')
          // }).finally(() => {
          //   this.loading = false
          // })
        } else {
          // console.log(err)
        }
      })
    }
  }
}
</script>
